// Retro arcade sound engine using Web Audio API.
// No external assets; every beep is generated in-browser.

let ctx = null;
let muted = false;

function getCtx() {
    if (typeof window === "undefined") return null;
    if (!ctx) {
        const AudioCtx = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtx) return null;
        ctx = new AudioCtx();
    }
    if (ctx.state === "suspended") {
        ctx.resume().catch(() => {});
    }
    return ctx;
}

function beep({ freq = 440, duration = 0.08, type = "square", volume = 0.08, slideTo = null } = {}) {
    if (muted) return;
    const audio = getCtx();
    if (!audio) return;
    const now = audio.currentTime;
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.type = type;
    osc.frequency.setValueAtTime(freq, now);
    if (slideTo !== null) {
        osc.frequency.linearRampToValueAtTime(slideTo, now + duration);
    }
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(volume, now + 0.005);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    osc.connect(gain).connect(audio.destination);
    osc.start(now);
    osc.stop(now + duration + 0.02);
}

export const sfx = {
    click: () => beep({ freq: 660, duration: 0.05, type: "square", volume: 0.06 }),
    move: () => beep({ freq: 220, duration: 0.04, type: "square", volume: 0.05 }),
    eat: () => beep({ freq: 880, duration: 0.12, type: "square", volume: 0.09, slideTo: 1400 }),
    gameOver: () => {
        beep({ freq: 320, duration: 0.18, type: "sawtooth", volume: 0.09, slideTo: 80 });
        setTimeout(() => beep({ freq: 160, duration: 0.28, type: "sawtooth", volume: 0.09, slideTo: 50 }), 180);
    },
    win: () => {
        beep({ freq: 660, duration: 0.09, type: "square", volume: 0.09 });
        setTimeout(() => beep({ freq: 880, duration: 0.09, type: "square", volume: 0.09 }), 100);
        setTimeout(() => beep({ freq: 1320, duration: 0.16, type: "square", volume: 0.09 }), 200);
    },
    match: () => {
        beep({ freq: 780, duration: 0.08, type: "triangle", volume: 0.08 });
        setTimeout(() => beep({ freq: 1180, duration: 0.1, type: "triangle", volume: 0.08 }), 90);
    },
    fail: () => beep({ freq: 180, duration: 0.16, type: "sawtooth", volume: 0.08, slideTo: 90 }),
    reveal: () => beep({ freq: 520, duration: 0.06, type: "sine", volume: 0.06 }),
    tick: () => beep({ freq: 1200, duration: 0.03, type: "square", volume: 0.04 }),
    coin: () => {
        beep({ freq: 987, duration: 0.06, type: "square", volume: 0.09 });
        setTimeout(() => beep({ freq: 1318, duration: 0.14, type: "square", volume: 0.09 }), 60);
    },
};

export function setMuted(value) {
    muted = value;
}

export function isMuted() {
    return muted;
}

export function toggleMute() {
    muted = !muted;
    return muted;
}
